/* Zolira — petits comportements sur Dawn (notre code). */
(() => {
  /* Flèches rondes sur la grande image produit, en mobile (modèle standard). */
  const CHEV = '<svg viewBox="0 0 21 21" fill="none" aria-hidden="true"><path d="M8 4.5l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const initArrows = (root) => {
    root.querySelectorAll('[id^="MainProduct-template--"] media-gallery > slider-component.slider-mobile-gutter:not(.thumbnail-slider)').forEach((sc) => {
      if (sc.querySelector('.zlr-media-arrow')) return;
      const list = sc.querySelector('.product__media-list');
      if (!list || list.children.length < 2) return;
      sc.style.position = 'relative';
      const mk = (dir) => {
        const b = document.createElement('button');
        b.type = 'button'; b.className = `zlr-media-arrow zlr-media-arrow--${dir}`;
        b.setAttribute('aria-label', dir === 'prev' ? 'Image précédente' : 'Image suivante');
        b.innerHTML = dir === 'prev' ? CHEV.replace('<path', '<path transform="rotate(180 10.5 10.5)"') : CHEV;
        b.addEventListener('click', () => {
          const item = list.querySelector('.product__media-item');
          const step = item ? item.getBoundingClientRect().width + parseFloat(getComputedStyle(list).columnGap || 0) : list.clientWidth;
          list.scrollBy({ left: dir === 'prev' ? -step : step, behavior: 'smooth' });
        });
        sc.appendChild(b); return b;
      };
      const prev = mk('prev'), next = mk('next');
      const update = () => {
        prev.disabled = list.scrollLeft <= 2;
        next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
      };
      list.addEventListener('scroll', update, { passive: true });
      update();
    });
  };
  initArrows(document);
  document.addEventListener('shopify:section:load', (e) => initArrows(e.target));
})();

/* ---------- Carrousels <splide-component> de nos fiches : bibliothèque Splide (MIT), réglages lus dans le balisage ---------- */
(() => {
  const num = (v, d) => (v === undefined || v === null || v === '' || isNaN(+v) ? d : +v);
  const pad = (side, calc) => (calc === 'false' ? { left: 0, right: side } : { left: side, right: side });
  const define = () => {
    if (customElements.get('splide-component')) return;
    class ZlrSplide extends HTMLElement {
      connectedCallback() {
        if (this._splide) return;
        const root = this.querySelector(':scope > .splide') || this.querySelector('.splide');
        if (!root || !window.Splide) return;
        const d = this.dataset;
        const mobile = {
          type: d.type || 'slide', perPage: num(d.slidesMobile, 1), perMove: num(d.perMoveMobile, 1),
          gap: num(d.gapMobile, 0), padding: pad(num(d.sidePaddingMobile, 0), d.paddingCalcMobile),
          arrows: d.arrows !== 'false', pagination: d.pagination !== 'false',
          autoplay: d.autoplay === 'true', interval: num(d.autoplaySpeed, 5) * 1000, pauseOnHover: true,
          rewind: d.type !== 'loop', speed: 400, mediaQuery: 'min', destroy: false,
        };
        const desktop = {
          perPage: num(d.slidesDesktop, 1), perMove: num(d.perMoveDesktop, 1), gap: num(d.gapDesktop, 0),
          padding: pad(num(d.sidePaddingDesktop, 0), d.paddingCalcDesktop), destroy: d.destroyDesktop === 'true',
        };
        root.style.setProperty('--zlr-gap-desktop', num(d.gapDesktop, 40) + 'px');
        const s = new window.Splide(root, Object.assign({}, mobile, { breakpoints: { 750: desktop } }));
        const arrowsColor = d.arrowsColor ? 'color-' + d.arrowsColor : '';
        const dotsColor = d.dotsColor ? ['color-' + d.dotsColor, 'dots-custom-color'] : [];
        const dress = () => {
          let box = root.querySelector(':scope > .splide__dots-and-arrows');
          if (!box) { box = document.createElement('div'); box.className = 'splide__dots-and-arrows'; root.appendChild(box); }
          const pg = root.querySelector('.splide__pagination'); const ar = root.querySelector('.splide__arrows');
          if (pg && pg.parentElement !== box) box.appendChild(pg);
          if (ar && ar.parentElement !== box) box.appendChild(ar);
          if (arrowsColor) root.querySelectorAll('.splide__arrow').forEach((b) => b.classList.add(arrowsColor));
          root.querySelectorAll('.splide__pagination__page').forEach((b) => b.classList.add(...dotsColor));
        };
        const pauseVideos = () => {
          if (d.pauseVideos !== 'true') return;
          root.querySelectorAll('.splide__slide:not(.is-visible) video').forEach((v) => v.pause());
        };
        // une diapositive à la fois : la liste prend la hauteur de celle affichée (comme l'ancien thème), pas de la plus haute
        const fit = () => {
          const list = root.querySelector('.splide__list');
          const cur = s.Components.Slides.getAt(s.index);
          if (!list) return;
          if (s.options.perPage === 1 && !s.options.destroy && cur) {
            list.style.alignItems = 'flex-start';
            list.style.height = cur.slide.offsetHeight + 'px';
          } else { list.style.alignItems = ''; list.style.height = ''; }
        };
        s.on('mounted pagination:mounted arrows:mounted updated', dress);
        s.on('mounted move updated resized', fit);
        s.on('moved', pauseVideos);
        s.mount();
        dress();
        root.querySelectorAll('img').forEach((i) => i.addEventListener('load', fit));
        window.addEventListener('load', fit);
        this._splide = s;
      }
    }
    customElements.define('splide-component', ZlrSplide);
  };
  if (window.Splide) define();
  else window.addEventListener('zlr:splide-ready', define, { once: true });
})();

/* ---------- <internal-video> : vidéo en lecture automatique, muette, en boucle, chargée quand elle approche ---------- */
(() => {
  if (customElements.get('internal-video')) return;
  class ZlrVideo extends HTMLElement {
    connectedCallback() {
      const v = this.querySelector('video'); if (!v) return;
      const load = () => {
        v.querySelectorAll('source[data-src]').forEach((s) => { s.src = s.dataset.src; s.removeAttribute('data-src'); });
        v.load();
        if (this.dataset.autoplay === 'true') { v.muted = true; v.play().catch(() => {}); }
      };
      const io = new IntersectionObserver((es) => es.forEach((e) => {
        if (!e.isIntersecting) { if (!v.paused && this._loaded) v.pause(); return; }
        if (!this._loaded) { this._loaded = true; load(); } else if (this.dataset.autoplay === 'true') v.play().catch(() => {});
      }), { rootMargin: '200px' });
      io.observe(this);
      this.addEventListener('click', (e) => {
        if (this.dataset.noPlayBtn === 'true') return;
        if (e.target.closest('a,button:not(.internal-video__play)')) return;
        if (v.paused) { v.play().catch(() => {}); this.classList.add('internal-video--playing'); }
        else { v.pause(); this.classList.remove('internal-video--playing'); }
      });
    }
  }
  customElements.define('internal-video', ZlrVideo);
})();

/* ---------- <content-tabs> : onglets numérotés, fond actif qui glisse, hauteur = onglet actif ---------- */
(() => {
  if (customElements.get('content-tabs')) return;
  class ZlrTabs extends HTMLElement {
    connectedCallback() {
      this.buttons = [...this.querySelectorAll('.content-tab-button-js')];
      this.tabs = [...this.querySelectorAll('.content-tabs__tabs-js > .content-tab')];
      this.bg = this.querySelector('.content-tab-buttom__active-bg');
      this.wrap = this.querySelector('.content-tabs__tabs-js');
      this.buttons.forEach((b) => b.addEventListener('click', () => this.select(+b.dataset.index)));
      const i = Math.max(0, this.buttons.findIndex((b) => b.classList.contains('content-tab-button--active')));
      this.select(i, true);
      window.addEventListener('resize', () => this.select(this.current, true));
      this.querySelectorAll('img').forEach((img) => img.complete || img.addEventListener('load', () => this.select(this.current, true), { once: true }));
    }
    select(i, instant) {
      this.current = i;
      this.buttons.forEach((b, j) => b.classList.toggle('content-tab-button--active', j === i));
      this.tabs.forEach((t, j) => t.classList.toggle('content-tab--active', j === i));
      const b = this.buttons[i];
      if (this.bg && b) {
        Object.assign(this.bg.style, { width: b.offsetWidth + 'px', height: b.offsetHeight + 'px',
          top: b.offsetTop + 'px', left: b.offsetLeft + 'px', transitionDuration: instant ? '0s' : '0.4s' });
        if (instant) requestAnimationFrame(() => (this.bg.style.transitionDuration = '0.4s'));
      }
      const t = this.tabs[i];
      if (this.wrap && t) this.wrap.style.height = t.offsetHeight + 'px';
    }
  }
  customElements.define('content-tabs', ZlrTabs);
})();

/* ---------- <sticky-atc> : barre d'achat en bas d'écran une fois le bouton principal dépassé ---------- */
(() => {
  if (customElements.get('sticky-atc')) return;
  class ZlrSticky extends HTMLElement {
    connectedCallback() {
      const btn = this.querySelector('.sticky-atc__add_button');
      const formId = btn && btn.getAttribute('form');
      const form = formId && document.getElementById(formId);
      const mainBtn = form && (form.querySelector('[type="submit"]') || form.querySelector('.product-form__submit'));
      const update = () => {
        if (!mainBtn) return;
        const past = this.dataset.afterScroll === 'true' ? mainBtn.getBoundingClientRect().bottom < 0 : true;
        this.classList.toggle('zlr-sticky-visible', past);
      };
      window.addEventListener('scroll', update, { passive: true });
      update();
      if (btn && mainBtn) btn.addEventListener('click', (e) => { e.preventDefault(); mainBtn.click(); });
    }
  }
  customElements.define('sticky-atc', ZlrSticky);
})();

/* ---------- Tiroir panier : ventes additionnelles à interrupteur (page de la couette) ---------- */
(() => {
  const refreshDrawer = async () => {
    // rendu des sections dans le contexte de la page (les ventes additionnelles dépendent de l'URL)
    const data = await (await fetch(`${location.pathname}?sections=cart-drawer,cart-icon-bubble`)).json();
    const parse = (h) => new DOMParser().parseFromString(h, 'text/html');
    const fresh = parse(data['cart-drawer']).querySelector('.drawer__inner'); const cur = document.querySelector('cart-drawer .drawer__inner');
    if (fresh && cur) cur.replaceWith(fresh);
    const bubble = document.getElementById('cart-icon-bubble'); const fb = parse(data['cart-icon-bubble']).querySelector('.shopify-section');
    if (bubble && fb) bubble.innerHTML = fb.innerHTML;
    const cart = await (await fetch('/cart.js')).json();
    const drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.toggle('is-empty', cart.item_count === 0);
  };
  const pickVariant = (box) => {
    const variants = JSON.parse(box.querySelector('.zlr-upsell__variants').textContent);
    const chosen = [...box.querySelectorAll('select')].map((s) => s.value);
    if (!chosen.length) return variants[0] && variants[0].id;
    const v = variants.find((x) => chosen.every((val, i) => x.options[i] === val));
    return v && v.id;
  };
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.zlr-upsell__toggle'); if (!btn) return;
    const box = btn.closest('.zlr-upsell'); box.classList.add('is-busy');
    try {
      if (box.classList.contains('is-on') && box.dataset.lineKey) {
        await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: box.dataset.lineKey, quantity: 0 }) });
      } else {
        const id = pickVariant(box); if (!id) return;
        await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id, quantity: 1 }] }) });
      }
      await refreshDrawer();
    } finally { box.classList.remove('is-busy'); }
  });
  document.addEventListener('change', async (e) => {
    const sel = e.target.closest('.zlr-upsell select'); if (!sel) return;
    const box = sel.closest('.zlr-upsell');
    if (!box.classList.contains('is-on') || !box.dataset.lineKey) return;
    const id = pickVariant(box); if (!id) return;
    box.classList.add('is-busy');
    try {
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: box.dataset.lineKey, quantity: 0 }) });
      await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id, quantity: 1 }] }) });
      await refreshDrawer();
    } finally { box.classList.remove('is-busy'); }
  });
})();

/* ---------- <product-form> de nos fiches sur mesure : ajout au panier en AJAX + ouverture du tiroir (même appel que Dawn) ----------
   Sur le modèle standard, Dawn charge son propre product-form.js avant nous : cette définition n'est alors pas utilisée. */
(() => {
  if (customElements.get('product-form')) return;
  class ZlrProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      const idInput = this.form.querySelector('[name=id]'); if (idInput) idInput.disabled = false;
      this.form.addEventListener('submit', (e) => this.onSubmit(e));
    }
    async onSubmit(e) {
      e.preventDefault();
      const btn = this.form.querySelector('[type="submit"]') || this.querySelector('[type="submit"]');
      if (btn && btn.getAttribute('aria-disabled') === 'true') return;
      if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
      const spin = this.querySelector('.loading__spinner, .loading-overlay__spinner');
      if (spin) spin.classList.remove('hidden');
      const errWrap = this.querySelector('.product-form__error-message-wrapper');
      const cart = document.querySelector('cart-drawer');
      const fd = new FormData(this.form);
      if (cart && cart.getSectionsToRender) {
        fd.append('sections', cart.getSectionsToRender().map((s) => s.id));
        fd.append('sections_url', window.location.pathname);
      }
      try {
        const res = await fetch('/cart/add', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd });
        const data = await res.json();
        if (data.status) {
          if (errWrap) { errWrap.hidden = false; const m = errWrap.querySelector('.product-form__error-message'); if (m) m.textContent = data.description || data.message; }
          return;
        }
        if (errWrap) errWrap.hidden = true;
        if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: fd.get('id'), cartData: data });
        if (cart && cart.renderContents) { cart.classList.remove('is-empty'); cart.renderContents(data); }
        else window.location = '/cart';
      } catch (err) {
        console.error(err);
      } finally {
        if (btn) { btn.classList.remove('loading'); btn.removeAttribute('aria-disabled'); }
        if (spin) spin.classList.add('hidden');
      }
    }
  }
  customElements.define('product-form', ZlrProductForm);
})();

/* ---------- Sélecteur de variantes du modèle standard ---------- */
(() => {
  const zlrCur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'SEK';
  const money = (c) => (zlrCur === 'XOF' || zlrCur === 'XAF') ? String(Math.round(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' FCFA' : (c / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' kr';
  document.querySelectorAll('.zlr-vp').forEach((vp) => {
    const variants = JSON.parse(vp.querySelector('.zlr-vp__data').textContent);
    const sid = vp.dataset.section;
    const root = document.getElementById(`MainProduct-${sid}`) || document;
    const chosen = () => [...vp.querySelectorAll('.zlr-vp__option')].map((o) => {
      const r = o.querySelector('input:checked'); return r ? r.value : o.querySelector('select').value; });
    const update = () => {
      const opts = chosen();
      vp.querySelectorAll('.zlr-vp__option').forEach((o, i) => { o.querySelector('.zlr-vp__current').textContent = opts[i]; });
      vp.querySelectorAll('.zlr-vp__swatch').forEach((s) => s.classList.toggle('is-selected', s.querySelector('input').checked));
      const v = variants.find((x) => x.options.every((val, i) => val === opts[i]));
      const btn = root.querySelector('.product-form__submit');
      if (!v) { if (btn) btn.disabled = true; return; }
      root.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach((i) => { i.value = v.id; i.disabled = false; });
      root.querySelectorAll('.price-item--regular, .price-item--sale').forEach((p) => {
        p.textContent = p.closest('s') ? (v.compare_at_price ? money(v.compare_at_price) : '') : money(v.price); });
      if (btn) { btn.disabled = !v.available; }
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      if (v.featured_media) {
        const gallery = root.querySelector('media-gallery');
        if (gallery && gallery.setActiveMedia) gallery.setActiveMedia(`${sid}-${v.featured_media.id}`, true);
      }
    };
    vp.addEventListener('change', update);
  });
})();

/* ---------- Points de navigation des galeries de nos fiches (mobile) : point actif selon la diapositive, clic = défilement ---------- */
(() => {
  document.querySelectorAll('[id*="__zlr_"] media-gallery').forEach((g) => {
    const list = g.querySelector('.product__media-list'); const dots = [...g.querySelectorAll('.slider__dots .slider-counter__link--dots')];
    if (!list || !dots.length) return;
    const slides = () => [...list.children].filter((li) => li.offsetParent !== null);
    const step = () => { const s = slides(); return s.length > 1 ? s[1].offsetLeft - s[0].offsetLeft : list.clientWidth; };
    const sync = () => { const i = Math.round(list.scrollLeft / (step() || 1));
      dots.forEach((d, j) => d.classList.toggle('slider-counter__link--active', j === i)); };
    dots.forEach((d, j) => d.addEventListener('click', (e) => { e.preventDefault(); list.scrollTo({ left: j * step(), behavior: 'smooth' }); }));
    list.addEventListener('scroll', sync, { passive: true }); sync();
  });
})();
